import * as React from "react";
import {
  Button,
  Grid,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Typography,
  Paper as MuiPaper,
  MenuItem,
  Select,
  CircularProgress,
  Checkbox,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  FormControlLabel,
  Switch,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
import useAuth from "../../../hooks/useAuth";
import Link from "@mui/material/Link";
import { NavLink, useNavigate } from "react-router-dom";
import { Box, spacing } from "@mui/system";
import styled from "@emotion/styled";
import { useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ptBR } from "date-fns/locale";
import { useEffect } from "react";
import PropTypes from "prop-types";

export default function CreateFinePaymentComponent({createCompoment}) {
  let { getApi, postApi, user, signUpStep2, isBSAccount, isInitializedBS } =
    useAuth();
  const [tabVal, setTabVal] = React.useState(0);

 let { 
    applyFees,
setApplyFees,
setTFineValue,
fine_value,
setTInterestValue,
interest_value
  } = createCompoment;
  

  return (
    <React.Fragment>
    <Grid container spacing={6}>
                  <Grid item md={4}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={applyFees}
                          onChange={(e) => setApplyFees(!applyFees)}
                          name="gilad"
                        />
                      }
                      label="Aplicar multa após o vencimento"
                    />
                  </Grid>
                </Grid>

                {applyFees && (
                  <Grid container spacing={6} mt={1}>
                    <Grid item md={3}>
                      <FormControl variant="outlined">
                        <InputLabel htmlFor="outlined-adornment-amount">
                          Multa
                        </InputLabel>
                        <OutlinedInput
                          id="outlined-adornment-weight"
                          endAdornment={
                            <InputAdornment position="end">%</InputAdornment>
                          }
                          label="Multa"
                          type={"number"}
                          step={0.01}
                          max={20}
                          onChange={(e) => setTFineValue(e.target.value)}
                          value={parseFloat(fine_value).toFixed(2)}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item md={3}>
                      <FormControl variant="outlined">
                        <InputLabel htmlFor="outlined-adornment-amount">
                          Juros ao mês
                        </InputLabel>
                        <OutlinedInput
                          id="outlined-adornment-weight"
                          endAdornment={
                            <InputAdornment position="end">%</InputAdornment>
                          }
                          label="Juros ao mês"
                          type={"number"}
                          step={0.01}
                          max={20}
                          onChange={(e) => setTInterestValue(e.target.value)}
                          value={parseFloat(interest_value).toFixed(2)}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                )}
    </React.Fragment>
  );
}

